export const version = '1.0.8';
export const build = ':d2b190b';
export const buildTime = '1793810945342';
